// Build-time gate for the command-center (/web/*) routes.
//
// The production promotion excludes the new command-center UI: prod builds
// leave this unset, so every /web/* URL falls through to the app's existing
// unknown-route handling (NotFoundRedirect -> DEFAULT_HOME when logged in,
// /login otherwise). Staging and the commandcenter demo build set
// REACT_APP_COMMAND_CENTER_ENABLED=1 to keep the routes mounted. Read once at
// module load — CRA inlines the value at build time, so this is a
// compile-time constant per deployment.
//
// Note: a build that disables this flag must NOT point REACT_APP_DEFAULT_HOME
// at /web/overview (defaultHome.js) — the landing route would then be an
// unknown route and NotFoundRedirect would loop.
export const COMMAND_CENTER_ENABLED =
  process.env.REACT_APP_COMMAND_CENTER_ENABLED === "1";
